export const VBP_MAY2021_EXPERIMENT_NAME = 'vbp_2_0_starter'
export const SEND_EMPTY_FIELDS_TO_MARKETO_FF = 'send_empty_fields_to_marketo_ff'

/**
 * These keys correspond to Optimizely experiments that should be ran on EVERY PAGE of the site.
 * A test can be safely added or removed from this list at any time, before or after de/activation.
 */
export const FULL_SITE_EXPERIMENTS = [
  SEND_EMPTY_FIELDS_TO_MARKETO_FF,
  VBP_MAY2021_EXPERIMENT_NAME,
  'email_verification_test',
]
